import { defineComponent as _defineComponent } from 'vue'
import { queries } from "@/apollo";
import { computed } from 'vue'
import { formatDollar } from "@/helpers/formatDollar";
import { negateNumber } from "@/helpers/negateNumber";
import { printNumCountName } from "@/helpers/tt/printNumCountName";
import { useQuery } from "@vue/apollo-composable";
import CompanyPlTable from "./CompanyPlTable.vue";
import { useTranslation } from "@/store/translation";
import { FEATURE_TOGGLES } from "@/config";



export default /*#__PURE__*/_defineComponent({
  __name: 'TtStakeReportByNumCount',
  props: {
    numCount: null,
    selectedStartReleaseDate: null,
    selectedEndReleaseDate: null
  },
  setup(__props: any) {

const props = __props as {
  numCount?: number;
  selectedStartReleaseDate: string;
  selectedEndReleaseDate: string;
};



const { $t } = useTranslation();

const ttCompanyReportQuery = FEATURE_TOGGLES.useV1Legacy
  ? queries.ttCompanyReportLegacy
  : queries.ttCompanyReport;

const { result, loading } = useQuery(ttCompanyReportQuery,
  {
    releaseDateStart: computed(() => props.selectedStartReleaseDate),
    releaseDateEnd: computed(() => props.selectedEndReleaseDate),
    numCount: props.numCount,
  },
  { fetchPolicy: "cache-and-network" },
);

const reportTitle = computed(() => {
  if (props.numCount) {
    return printNumCountName(props.numCount);
  }
  return FEATURE_TOGGLES.useV1Legacy ? "All" : "Company Profit/Loss Report";
});

const ttCompanyReport = computed(() => {
  return result.value?.ttCompanyReport as
    | {
        expenses?: number;
        companyTicketsFinal?: { summary?: Record<string, number | string> };
        companyTicketsFinalLessExpenses?: {
          summary?: Record<string, number | string>;
        };
      }
    | undefined;
});

const companyTicketsFinal = computed(() => {
  if (FEATURE_TOGGLES.useV1Legacy) {
    return (
      ttCompanyReport.value?.companyTicketsFinalLessExpenses ??
      ttCompanyReport.value?.companyTicketsFinal
    );
  }
  return ttCompanyReport.value?.companyTicketsFinal;
});

// const winLossPercent = computed(() => {

//   const net = result.value?.ttCompanyReport.companyTicketsFinal.summary
//     .net;
//   const amountLessRebate = result.value?.ttCompanyReport.companyTickets.summary
//     .amountLessRebate;

//   if (net == null || amountLessRebate == null) {
//     return null;
//   }
//   const ratio = net / amountLessRebate;
//   return isFinite(ratio) ? ((net / amountLessRebate) * 100).toFixed(2) : 0;

// })



return { __sfc: true,props, $t, ttCompanyReportQuery, result, loading, reportTitle, ttCompanyReport, companyTicketsFinal, formatDollar, negateNumber, CompanyPlTable, FEATURE_TOGGLES }
}

})